import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[lasLink]',
    standalone: false,
})
export class LinkDirective implements AfterViewInit {
    href = 'href';

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngAfterViewInit() {
        const nativeElement = this.el.nativeElement;
        const href = nativeElement.getAttribute(this.href);
        if (!isValidHref(href)) {
            this.renderer.setAttribute(nativeElement, this.href, `//${href}`);
        }
    }
}

export function isValidHref(href: string): boolean {
    return (
        href !== null &&
        ['//', 'http://', 'https://'].some((start) => href.startsWith(start))
    );
}
